import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { useUiStore } from '@/stores';
import { ROUTE_CHAT_ROOT } from '@/router/chat/routes';
import { IRouteMeta } from '@/core/models/routing';
import { AppCoreEnums } from '@/core/shared/enums';
import { AppMainMenuItem } from '@/stores/core/models';
import useAppi18n from '@/core/composable/use-app-i18n';
import { ROUTE_INDEXES } from '@/router/indexes/routes';
import { ROUTE_SUPPORT } from '@/router/support/routes';
import { ROUTE_EXPLORE_GPT } from '@/router/chatbots/routes';
import { ROUTE_KI_ENGINES } from '@/router/ki-engines/routes';
import { ROUTE_NOTIFICATIONS } from '@/router/notifications/routes';
import { ROUTE_CONFIGURATIONS } from '@/router/configurations/routes';
import { ROUTE_PROFILES } from '@/router/profiles/routes';
import { ROUTE_USERS } from '@/router/users/routes';
import { AppEnums } from '@/shared/enums';
import usePermissionChecker from '@/core/composable/use-permission-checker';

export default () => {
  const route = useRoute();
  const { t } = useAppi18n();
  const { isRouteChat, canSeeProfiles, canSeeChatbots } = storeToRefs(useUiStore());

  const getMenuItemLabel = (containerType: AppCoreEnums.ContainerType) => {
    const routeMatched = route.matched.find((x) => (x.meta as IRouteMeta)?.containerType == containerType);
    var label = (leftMenuItems.value.find((item) => item.route === routeMatched?.name)?.label as string) || '';
    if (!label) {
      const leftMenuItem = leftMenuItems.value.find((item) => item.items?.find((item) => item.route === routeMatched?.name));
      if (leftMenuItem) {
        label = leftMenuItem.items?.find((item) => item.route === routeMatched?.name)?.label as string;
      }
    }
    return label;
  };

  const leftMenuItems = computed(() => {
    const items = [
      {
        label: t('chat.title'),
        icon: 'hugeicons:wechat',
        route: ROUTE_CHAT_ROOT,
      },
      {
        label: t('indexes.title'),
        icon: 'hugeicons:layers-01',
        route: ROUTE_INDEXES,
      },
      {
        label: t('kiEngine.title'),
        icon: 'hugeicons:search-01',
        route: ROUTE_KI_ENGINES,
      },
    ] as AppMainMenuItem[];

    items.push({
      label: t('chatbots.title'),
      icon: 'hugeicons:ai-innovation-03',
      route: ROUTE_EXPLORE_GPT,
    });

    items.push({
      label: t('configurations.title'),
      icon: 'hugeicons:settings-01',
      route: ROUTE_CONFIGURATIONS,
      visible: false,
    });

    items.push({
      label: t('notifications.title'),
      icon: 'hugeicons:notification-03',
      route: ROUTE_NOTIFICATIONS,
    });

    items.push({
      label: t('support.title'),
      icon: 'hugeicons:pie-chart-08',
      route: ROUTE_SUPPORT,
    });

    items.push({
      label: t('profiles.title'),
      icon: 'hugeicons:user-shield-01',
      route: ROUTE_PROFILES,
      visible: false,
    });

    items.push({
      label: t('users.title'),
      icon: 'hugeicons:user-multiple-02',
      route: ROUTE_USERS,
    });

    return items;
  });

  return {
    leftMenuItems,
    getMenuItemLabel,
  };
};
